import React from 'react';
import '../styles/ServiceDetailPage.css';
import { useParams, Link } from 'react-router-dom';
import ClientLogos from '../components/ClientLogos';
import SEOHelmet from '../components/SEOHelmet';
import SocialMediaProjects from '../components/SocialMediaProjects';
import ProductionProjects from '../components/ProductionProjects';

const ServiceDetailPage = () => {
  const { serviceId } = useParams();

  // Hizmet verileri
  const serviceData = {
    'pr': {
      title: 'PR Hizmetleri',
      description: 'Markanızın hikayesini en etkili şekilde anlatmanız için stratejik PR çözümleri sunuyoruz.',
      features: [
        {
          title: 'Medya İlişkileri',
          icon: 'newspaper',
          content: 'Markanızın medyada doğru şekilde temsil edilmesi için kapsamlı medya ilişkileri yönetimi sağlıyoruz.'
        },
        {
          title: 'Kriz Yönetimi',
          icon: 'shield',
          content: 'Olası kriz durumlarında markanızın itibarını korumak için proaktif ve reaktif stratejiler geliştiriyoruz.'
        },
        {
          title: 'İçerik Üretimi',
          icon: 'edit',
          content: 'Markanızın mesajını güçlendiren, hedef kitlenizle etkileşim kuran özgün içerikler üretiyoruz.'
        },
        {
          title: 'Etkinlik Yönetimi',
          icon: 'calendar',
          content: 'Markanızın değerlerini ve mesajını yansıtan, hedef kitlenizle buluşturan etkinlikler düzenliyoruz.'
        },
        {
          title: 'İtibar Yönetimi',
          icon: 'star',
          content: 'Markanızın olumlu algısını güçlendiren, itibarını koruyan stratejik iletişim planları hazırlıyoruz.'
        },
        {
          title: 'Influencer İlişkileri',
          icon: 'users',
          content: 'Markanıza uygun influencerlar ile işbirlikleri geliştiriyor, etkili kampanyalar yürütüyoruz.'
        }
      ],
      category: 'pr'
    },
    'sosyal-medya': {
      title: 'Sosyal Medya Hizmetleri',
      description: 'Dijital dünyada markanızın sesini duyurmak ve etkileşimi artırmak için kapsamlı sosyal medya çözümleri.',
      features: [
        {
          title: 'Sosyal Medya Stratejisi',
          icon: 'strategy',
          content: 'Markanızın hedeflerine uygun, etkili sosyal medya stratejileri geliştiriyoruz.'
        },
        {
          title: 'İçerik Üretimi',
          icon: 'edit',
          content: 'Hedef kitlenizle etkileşim kuran, markanızın değerlerini yansıtan özgün içerikler üretiyoruz.'
        },
        {
          title: 'Topluluk Yönetimi',
          icon: 'users',
          content: 'Sosyal medya platformlarında markanızın topluluğunu yönetiyor, etkileşimi artırıyoruz.'
        },
        {
          title: 'Sosyal Medya Reklamları',
          icon: 'ad',
          content: 'Hedef kitlenize ulaşmanızı sağlayan, dönüşüm odaklı sosyal medya reklamları hazırlıyoruz.'
        },
        {
          title: 'Analiz ve Raporlama',
          icon: 'chart',
          content: 'Sosyal medya performansınızı detaylı olarak analiz ediyor, stratejik öneriler sunuyoruz.'
        },
        {
          title: 'Kriz Yönetimi',
          icon: 'shield',
          content: 'Sosyal medyada oluşabilecek kriz durumlarına hızlı ve etkili çözümler üretiyoruz.'
        }
      ],
      category: 'sosyalMedya'
    },
    'produksiyon': {
      title: 'Prodüksiyon Hizmetleri',
      description: 'Markanızın hikayesini görsel olarak anlatmanız için profesyonel prodüksiyon çözümleri.',
      features: [
        {
          title: 'Video Prodüksiyon',
          icon: 'video',
          content: 'Markanızın mesajını etkili bir şekilde ileten, yüksek kaliteli video içerikler üretiyoruz.'
        },
        {
          title: 'Fotoğraf Çekimi',
          icon: 'camera',
          content: 'Profesyonel ekipman ve ekibimizle markanıza özel fotoğraf çekimleri gerçekleştiriyoruz.'
        },
        {
          title: 'Animasyon',
          icon: 'film',
          content: 'Karmaşık mesajları basitleştiren, akılda kalıcı animasyon içerikleri hazırlıyoruz.'
        },
        {
          title: 'Ses Prodüksiyon',
          icon: 'microphone',
          content: 'Podcast, radyo spotları ve diğer ses içerikleri için profesyonel prodüksiyon hizmeti sunuyoruz.'
        },
        {
          title: 'Post-Prodüksiyon',
          icon: 'edit',
          content: 'Kurgu, renk düzenleme ve ses miksaj gibi post-prodüksiyon hizmetleri sağlıyoruz.'
        },
        {
          title: 'Canlı Yayın',
          icon: 'broadcast',
          content: 'Etkinlikleriniz için profesyonel canlı yayın ve streaming hizmetleri sunuyoruz.'
        }
      ],
      category: 'produksiyon'
    },
    'organizasyon': {
      title: 'Organizasyon Hizmetleri',
      description: 'Markanızın değerlerini yansıtan, unutulmaz etkinlikler için profesyonel organizasyon çözümleri.',
      features: [
        {
          title: 'Kurumsal Etkinlikler',
          icon: 'building',
          content: 'Şirket toplantıları, konferanslar ve seminerler için profesyonel organizasyon hizmetleri sunuyoruz.'
        },
        {
          title: 'Lansman Etkinlikleri',
          icon: 'rocket',
          content: 'Yeni ürün ve hizmetlerinizin tanıtımı için etki yaratan lansman organizasyonları düzenliyoruz.'
        },
        {
          title: 'Basın Toplantıları',
          icon: 'newspaper',
          content: 'Medya ile etkili iletişim kurmanızı sağlayan profesyonel basın toplantıları organize ediyoruz.'
        },
        {
          title: 'Özel Etkinlikler',
          icon: 'star',
          content: 'Markanızın değerlerini yansıtan, hedef kitlenizle buluşturan özel etkinlikler düzenliyoruz.'
        },
        {
          title: 'Fuar ve Sergi Organizasyonu',
          icon: 'map',
          content: 'Fuarlarda ve sergilerde markanızı en iyi şekilde temsil eden stand ve organizasyon hizmetleri sunuyoruz.'
        },
        {
          title: 'Sanal Etkinlikler',
          icon: 'laptop',
          content: 'Dijital platformlarda etkileşimli ve profesyonel sanal etkinlikler düzenliyoruz.'
        }
      ],
      category: 'organizasyon'
    },
    'studyo-hizmeti': {
      title: 'Stüdyo Hizmetleri',
      description: 'Profesyonel içerik üretimi için tam donanımlı stüdyo çözümleri.',
      features: [
        {
          title: 'Video Çekim Stüdyosu',
          icon: 'video',
          content: 'Profesyonel ekipmanlarla donatılmış video çekim stüdyomuzda yüksek kaliteli içerikler üretiyoruz.'
        },
        {
          title: 'Fotoğraf Stüdyosu',
          icon: 'camera',
          content: 'Ürün çekimlerinden portre fotoğraflara kadar her türlü fotoğraf çekimi için profesyonel stüdyo hizmeti sunuyoruz.'
        },
        {
          title: 'Ses Kayıt Stüdyosu',
          icon: 'microphone',
          content: 'Podcast, seslendirme ve müzik kayıtları için akustik olarak tasarlanmış ses kayıt stüdyosu hizmeti veriyoruz.'
        },
        {
          title: 'Green Screen',
          icon: 'film',
          content: 'Özel efekt ve arka plan değişimi gerektiren çekimler için green screen teknolojisi sunuyoruz.'
        },
        {
          title: 'Ekipman Kiralama',
          icon: 'tools',
          content: 'Profesyonel kamera, ışık ve ses ekipmanları kiralama hizmeti sağlıyoruz.'
        },
        {
          title: 'Post-Prodüksiyon Suiti',
          icon: 'edit',
          content: 'Kurgu, renk düzenleme ve ses miksaj işlemleri için tam donanımlı post-prodüksiyon imkanları sunuyoruz.'
        }
      ],
      category: 'studyo'
    }
  };

  // Geçerli hizmet verilerini al
  const service = serviceData[serviceId];

  // Hizmet bulunamadıysa
  if (!service) {
    return (
      <div className="container">
        <h1>Hizmet Bulunamadı</h1>
        <p>Aradığınız hizmet sayfası mevcut değil.</p>
        <Link to="/hizmetlerimiz" className="btn btn-primary">Tüm Hizmetlerimiz</Link>
      </div>
    );
  }

  return (
    <div className="service-detail-page">
      <SEOHelmet
        title={`${service.title} | 5N1PR İletişim Danışmanlığı`}
        description={service.description}
      />

      {/* Hero Section */}
      <section className="service-hero">
        <div className="container">
          <div className="service-hero-content">
            <h1>{service.title}</h1>
            <p className="service-hero-description">{service.description}</p>
          </div>
        </div>
      </section>

      {/* Service Features */}
      <section className="service-features">
        <div className="container">
          <h2 className="section-title">Neler Sunuyoruz?</h2>
          <p className="section-description">
            Markanızın ihtiyaçlarına özel, profesyonel çözümler sunuyoruz.
          </p>

          <div className="feature-grid">
            {service.features.map((feature, index) => (
              <div className="feature-card" key={index}>
                <div className="feature-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    {feature.icon === 'newspaper' && <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />}
                    {feature.icon === 'shield' && <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />}
                    {feature.icon === 'edit' && <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />}
                    {feature.icon === 'calendar' && <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zm-7 5h5v5h-5v-5z" />}
                    {feature.icon === 'star' && <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />}
                    {feature.icon === 'users' && <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />}
                    {feature.icon === 'strategy' && <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" />}
                    {feature.icon === 'ad' && <path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 9H3V5h9v7z" />}
                    {feature.icon === 'chart' && <path d="M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z" />}
                    {feature.icon === 'video' && <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" />}
                    {feature.icon === 'camera' && <path d="M9.4 10.5l4.77-8.26C13.47 2.09 12.75 2 12 2c-2.4 0-4.6.85-6.32 2.25l3.66 6.35.06-.1zM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66zm.26 1h-7.49l.29.5 4.76 8.25C21 16.97 22 14.61 22 12c0-.69-.07-1.35-.2-2zM8.54 12l-3.9-6.75C3.01 7.03 2 9.39 2 12c0 .69.07 1.35.2 2h7.49l-1.15-2zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46zm11.27 0l-3.9 6.76c.7.15 1.42.24 2.17.24 2.4 0 4.6-.85 6.32-2.25l-3.66-6.35-.93 1.6z" />}
                    {feature.icon === 'film' && <path d="M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z" />}
                    {feature.icon === 'microphone' && <path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z" />}
                    {feature.icon === 'broadcast' && <path d="M12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6m0-2c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1s1-.45 1-1V8c0-.55-.45-1-1-1z" />}
                    {feature.icon === 'building' && <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />}
                    {feature.icon === 'rocket' && <path d="M12 2.5s4.5 2.04 4.5 10.5c0 2.49-1.04 5.57-1.6 7H9.1c-.56-1.43-1.6-4.51-1.6-7C7.5 4.54 12 2.5 12 2.5zm2 8.5c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-6.31 9.52c-.48-1.23-1.52-4.17-1.67-6.87l-1.13.75c-.56.38-.89 1-.89 1.67V22l3.69-1.48zM20 22v-5.93c0-.67-.33-1.29-.89-1.66l-1.13-.75c-.15 2.69-1.2 5.64-1.67 6.87L20 22z" />}
                    {feature.icon === 'map' && <path d="M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z" />}
                    {feature.icon === 'laptop' && <path d="M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z" />}
                    {feature.icon === 'tools' && <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z" />}
                  </svg>
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.content}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Project Showcase - Sadece sosyal medya ve prodüksiyon için göster */}
      {(serviceId === 'sosyal-medya' || serviceId === 'produksiyon') && (
        <section className="service-projects">
          <div className="container">
            <h2 className="section-title">Projelerimiz</h2>
          </div>
          {serviceId === 'sosyal-medya' && <SocialMediaProjects />}
          {serviceId === 'produksiyon' && (
            <div className="container">
              <ProductionProjects />
            </div>
          )}
        </section>
      )}

      {/* Client References - Organizasyon ve stüdyo hizmetleri hariç */}
      {serviceId !== 'organizasyon' && serviceId !== 'studyo-hizmeti' && (
        <section className="client-references">
          <div className="container">
            <h2 className="client-references-title section-title">Müşterilerimiz</h2>

            <ClientLogos category={service.category} />
          </div>
        </section>
      )}

      {/* CTA Section */}
      <section className="service-cta">
        <div className="container">
          <div className="service-cta-content">
            <h2>Projeleriniz İçin Bizimle İletişime Geçin</h2>
            <p>
              Markanızın ihtiyaçlarına özel çözümler sunmak için buradayız.
              Hemen bizimle iletişime geçin!
            </p>
            <Link to="/iletisim" className="btn btn-primary btn-large">İletişim Formu</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
export default ServiceDetailPage;